<template>
  <div class="app-container">
    <el-form :model="searchData" :inline="true" label-width="140px" label-position="right" ref="searchData">
      <el-form-item label="旧机品类" prop="specifications">
        <el-select clearable v-model="searchData.specifications" placeholder="请选择">
          <el-option v-for="item in specificationsList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="统计日期" prop="totalDate">
        <!-- 按日选择 -->
        <el-date-picker
          :key="'day-picker'"
          v-model="totalDate"
          type="daterange"
          :picker-options="dayPickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          @change="handleDayChange"
          :clearable="false"
        />
      </el-form-item>

      <el-form-item label="省份" prop="province">
        <el-select v-model="searchData.province" placeholder="请选择" clearable style="width: 100%" @change="getTblCity">
          <!-- 修改省份选项的数据源格式 -->
          <el-option v-for="item in provinceList" :key="item" :label="item" :value="item" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="城市" prop="city">
        <el-select v-model="searchData.city" placeholder="请选择" clearable style="width: 100%" :disabled="!searchData.province">
          <el-option v-for="item in cityList" :key="item" :label="item" :value="item" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="回收商" prop="recycler">
        <el-input v-model="searchData.recycler" placeholder="请输入" clearable></el-input>
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <div class="row-bg">
        <el-button size="medium" @click="importOrder">批量更新</el-button>

        <el-button ghost size="medium" @click="exportBtnFun" :loading="exportFlag">导出</el-button>
      </div>
      <el-alert style="margin: 0 16px;" :title="`检索出${total}条数据, 旧机价值总计: ${totalPrice}, 旧机信息费总计: ${totalInfoFee}`" type="success" show-icon :closable="false">
      </el-alert>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table ref="checktableData" :data="tableData" v-loading="tableLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="操作" prop="action" width="140">
        <template slot-scope="scope">
          <el-link type="primary" style="margin-right: 12px;" @click="openTotalPriceUpdateModal(scope.row)" v-if="scope.row.status != 1">修改</el-link>
          <el-popconfirm title="确定删除吗？" @confirm="handleDelete(scope.row)">
            <el-link slot="reference" type="primary">删除</el-link>
          </el-popconfirm>
          <el-link style="margin-left: 12px;" type="primary" @click="handleSave(scope.row)" v-if="scope.row.status != 1">存档</el-link>
        </template>
      </el-table-column>
      <el-table-column label="统计日期" prop="totalDate" min-width="100"></el-table-column>
      <el-table-column label="省" prop="province" min-width="100"></el-table-column>
      <el-table-column label="市" prop="city" min-width="100"></el-table-column>
      <el-table-column label="回收商" prop="recycler" min-width="100"></el-table-column>
      <el-table-column label="挂机价值" prop="airConditionerWallHangingPrice" min-width="100"></el-table-column>
      <el-table-column label="挂机数量" prop="airConditionerWallHangingCount" min-width="100"></el-table-column>
      <el-table-column label="挂机信息费" prop="airConditionerWallHangingInfoFee" min-width="100"></el-table-column>

      <el-table-column label="柜机价值" prop="airConditionerPackagedPrice" min-width="100"></el-table-column>
      <el-table-column label="柜机数量" prop="airConditionerPackagedCount" min-width="100"></el-table-column>
      <el-table-column label="柜机信息费" prop="airConditionerPackagedInfoFee" min-width="100"></el-table-column>

      <el-table-column label="移动空调价值" prop="airConditionerMobilePrice" min-width="100"></el-table-column>
      <el-table-column label="移动空调数量" prop="airConditionerMobileCount" min-width="100"></el-table-column>
      <el-table-column label="移动空调信息费" prop="airConditionerMobileInfoFee" min-width="100"></el-table-column>

      <el-table-column label="老式显像管电视(19寸及以上)价值" prop="televisionOldPrice" min-width="100"></el-table-column>
      <el-table-column label="老式显像管电视(19寸及以上)数量" prop="televisionOldCount" min-width="100"></el-table-column>
      <el-table-column label="老式显像管电视(19寸及以上)信息费" prop="televisionOldInfoFee" min-width="100"></el-table-column>

      <el-table-column label="液晶电视价值" prop="televisionNewPrice" min-width="100"></el-table-column>
      <el-table-column label="液晶电视数量" prop="televisionNewCount" min-width="100"></el-table-column>
      <el-table-column label="液晶电视信息费" prop="televisionNewInfoFee" min-width="100"></el-table-column>

      <el-table-column label="液晶（32-49寸）-屏幕完好显示正常价值" prop="television3249GoodPrice" min-width="100"></el-table-column>
      <el-table-column label="液晶（32-49寸）-屏幕完好显示正常数量" prop="television3249GoodCount" min-width="100"></el-table-column>
      <el-table-column label="液晶（32-49寸）-屏幕完好显示正常信息费" prop="television3249GoodInfoFee" min-width="100"></el-table-column>

      <el-table-column label="液晶（32-49寸）-屏幕破损/显示异常价值" prop="television3249BadPrice" min-width="100"></el-table-column>
      <el-table-column label="液晶（32-49寸）-屏幕破损/显示异常数量" prop="television3249BadCount" min-width="100"></el-table-column>
      <el-table-column label="液晶（32-49寸）-屏幕破损/显示异常信息费" prop="television3249BadInfoFee" min-width="100"></el-table-column>

      <el-table-column label="液晶（50-69寸）-屏幕完好显示正常价值" prop="television5069GoodPrice" min-width="100"></el-table-column>
      <el-table-column label="液晶（50-69寸）-屏幕完好显示正常数量" prop="television5069GoodCount" min-width="100"></el-table-column>
      <el-table-column label="液晶（50-69寸）-屏幕完好显示正常信息费" prop="television5069GoodInfoFee" min-width="100"></el-table-column>

      <el-table-column label="液晶（50-69寸）-屏幕破损/显示异常价值" prop="television5069BadPrice" min-width="100"></el-table-column>
      <el-table-column label="液晶（50-69寸）-屏幕破损/显示异常数量" prop="television5069BadCount" min-width="100"></el-table-column>
      <el-table-column label="液晶（50-69寸）-屏幕破损/显示异常信息费" prop="television5069BadInfoFee" min-width="100"></el-table-column>

      <el-table-column label="液晶（70寸以上）-屏幕完好显示正常价值" prop="television70PlusGoodPrice" min-width="100"></el-table-column>
      <el-table-column label="液晶（70寸以上）-屏幕完好显示正常数量" prop="television70PlusGoodCount" min-width="100"></el-table-column>
      <el-table-column label="液晶（70寸以上）-屏幕完好显示正常信息费" prop="television70PlusGoodInfoFee" min-width="100"></el-table-column>

      <el-table-column label="液晶（70寸以上）-屏幕破损/显示异常价值" prop="television70PlusBadPrice" min-width="100"></el-table-column>
      <el-table-column label="液晶（70寸以上）-屏幕破损/显示异常数量" prop="television70PlusBadCount" min-width="100"></el-table-column>
      <el-table-column label="液晶（70寸以上）-屏幕破损/显示异常信息费" prop="television70PlusBadInfoFee" min-width="100"></el-table-column>

      <el-table-column label="波轮全自动洗衣机（4公斤以上）价值" prop="washingMachineTumblePrice" min-width="100"></el-table-column>
      <el-table-column label="波轮全自动洗衣机（4公斤以上）数量" prop="washingMachineTumbleCount" min-width="100"></el-table-column>
      <el-table-column label="波轮全自动洗衣机（4公斤以上）信息费" prop="washingMachineTumbleInfoFee" min-width="100"></el-table-column>

      <el-table-column label="滚筒洗衣机（4公斤以上）价值" prop="washingMachineDrumPrice" min-width="100"></el-table-column>
      <el-table-column label="滚筒洗衣机（4公斤以上）数量" prop="washingMachineDrumCount" min-width="100"></el-table-column>
      <el-table-column label="滚筒洗衣机（4公斤以上）信息费" prop="washingMachineDrumInfoFee" min-width="100"></el-table-column>

      <el-table-column label="双缸洗衣机（4公斤以上）价值" prop="washingMachineDoublePrice" min-width="100"></el-table-column>
      <el-table-column label="双缸洗衣机（4公斤以上）数量" prop="washingMachineDoubleCount" min-width="100"></el-table-column>
      <el-table-column label="双缸洗衣机（4公斤以上）信息费" prop="washingMachineDoubleInfoFee" min-width="100"></el-table-column>

      <el-table-column label="冰箱（100升以上）价值" prop="fridgeOnePrice" min-width="100"></el-table-column>
      <el-table-column label="冰箱（100升以上）数量" prop="fridgeOneCount" min-width="100"></el-table-column>
      <el-table-column label="冰箱（100升以上）信息费" prop="fridgeOneInfoFee" min-width="100"></el-table-column>

      <el-table-column label="冰箱（100升以下）价值" prop="fridgeTwoPrice" min-width="100"></el-table-column>
      <el-table-column label="冰箱（100升以下）数量" prop="fridgeTwoCount" min-width="100"></el-table-column>
      <el-table-column label="冰箱（100升以下）信息费" prop="fridgeTwoInfoFee" min-width="100"></el-table-column>

      <el-table-column label="冷柜（200升以上）价值" prop="freezerPrice" min-width="100"></el-table-column>
      <el-table-column label="冷柜（200升以上）数量" prop="freezerCount" min-width="100"></el-table-column>
      <el-table-column label="冷柜（200升以上）信息费" prop="freezerInfoFee" min-width="100"></el-table-column>

      <el-table-column label="电热水器价值" prop="electricWaterHeaterPrice" min-width="100"></el-table-column>
      <el-table-column label="电热水器数量" prop="electricWaterHeaterCount" min-width="100"></el-table-column>
      <el-table-column label="电热水器信息费" prop="electricWaterHeaterInfoFee" min-width="100"></el-table-column>

      <el-table-column label="燃气热水器价值" prop="gasWaterHeaterPrice" min-width="100"></el-table-column>
      <el-table-column label="燃气热水器数量" prop="gasWaterHeaterCount" min-width="100"></el-table-column>
      <el-table-column label="燃气热水器信息费" prop="gasWaterHeaterInfoFee" min-width="100"></el-table-column>

      <el-table-column label="空气能热水器价值" prop="airEnergyWaterHeaterPrice" min-width="100"></el-table-column>
      <el-table-column label="空气能热水器数量" prop="airEnergyWaterHeaterCount" min-width="100"></el-table-column>
      <el-table-column label="空气能热水器信息费" prop="airEnergyWaterHeaterInfoFee" min-width="100"></el-table-column>

      <el-table-column label="壁挂炉价值" prop="wallHangingBoilerPrice" min-width="100"></el-table-column>
      <el-table-column label="壁挂炉数量" prop="wallHangingBoilerCount" min-width="100"></el-table-column>
      <el-table-column label="壁挂炉信息费" prop="wallHangingBoilerInfoFee" min-width="100"></el-table-column>

      <el-table-column label="洗碗机价值" prop="dishwasherPrice" min-width="100"></el-table-column>
      <el-table-column label="洗碗机数量" prop="dishwasherCount" min-width="100"></el-table-column>
      <el-table-column label="洗碗机信息费" prop="dishwasherInfoFee" min-width="100"></el-table-column>

      <el-table-column label="油烟机价值" prop="rangeHoodPrice" min-width="100"></el-table-column>
      <el-table-column label="油烟机数量" prop="rangeHoodCount" min-width="100"></el-table-column>
      <el-table-column label="油烟机信息费" prop="rangeHoodInfoFee" min-width="100"></el-table-column>

      <el-table-column label="燃气灶价值" prop="gasStovePrice" min-width="100"></el-table-column>
      <el-table-column label="燃气灶数量" prop="gasStoveCount" min-width="100"></el-table-column>
      <el-table-column label="燃气灶信息费" prop="gasStoveInfoFee" min-width="100"></el-table-column>

      <el-table-column label="烟灶套装价值" prop="rangeHoodStoveSetPrice" min-width="100"></el-table-column>
      <el-table-column label="烟灶套装数量" prop="rangeHoodStoveSetCount" min-width="100"></el-table-column>
      <el-table-column label="烟灶套装信息费" prop="rangeHoodStoveSetInfoFee" min-width="100"></el-table-column>

      <el-table-column label="集成灶价值" prop="integratedStovePrice" min-width="100"></el-table-column>
      <el-table-column label="集成灶数量" prop="integratedStoveCount" min-width="100"></el-table-column>
      <el-table-column label="集成灶信息费" prop="integratedStoveInfoFee" min-width="100"></el-table-column>

      <el-table-column label="嵌入式消毒柜价值" prop="embeddedDisinfectorPrice" min-width="100"></el-table-column>
      <el-table-column label="嵌入式消毒柜数量" prop="embeddedDisinfectorCount" min-width="100"></el-table-column>
      <el-table-column label="嵌入式消毒柜信息费" prop="embeddedDisinfectorInfoFee" min-width="100"></el-table-column>

      <el-table-column label="展示柜（100升~200升)价值" prop="showcaseOnePrice" min-width="100"></el-table-column>
      <el-table-column label="展示柜（100升~200升)数量" prop="showcaseOneCount" min-width="100"></el-table-column>
      <el-table-column label="展示柜（100升~200升)信息费" prop="showcaseOneInfoFee" min-width="100"></el-table-column>

      <el-table-column label="展示柜（200升以上）价值" prop="showcaseTwoPrice" min-width="100"></el-table-column>
      <el-table-column label="展示柜（200升以上）数量" prop="showcaseTwoCount" min-width="100"></el-table-column>
      <el-table-column label="展示柜（200升以上）信息费" prop="showcaseTwoInfoFee" min-width="100"></el-table-column>

      <el-table-column label="旧机总价值" prop="totalPrice" min-width="100"></el-table-column>
      <el-table-column label="旧机总数量" prop="totalCount" min-width="100"></el-table-column>
      <el-table-column label="总信息费" prop="totalInfoFee" min-width="100"></el-table-column>

      <el-table-column label="更新时间" prop="lastModifiedDate" min-width="200"></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pagination.page"
        :page-size="pagination.rows"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog title="批量更新" :visible.sync="dialogVisible" width="400px" top="32vh" center>
      <div>
        <el-row type="flex" justify="center" class="row-bg">
          <el-col :span="8" class="font-blod">下载excel模版</el-col>
          <el-col :span="8">
            <el-button type="primary" @click="download()">
              <div class="btnclass">
                <img src="@/assets/download.png" alt="" />
                <span>excel模版下载</span>
              </div>
            </el-button>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" class="row-bg">
          <el-col :span="8" class="font-blod">导入excel</el-col>
          <el-col :span="8">
            <file-upload ref="Defaultfileupload" @addUpload="importUpdateDefaultByExcel" @removeUpload="removueFile" :title="'+导入excel文件'" :limit="1" v-if="Default" />
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="tableBtn">
        <div @click="dialogVisible = false">取 消</div>
        <div @click="submitExcel()">确认导入</div>
      </div>
    </el-dialog>
    <total-price-update-modal :type="'normal'" ref="totalPriceUpdateModalRef" @submit="handleSearch()" @getList="handleSearch()"></total-price-update-modal>
  </div>
</template>
<script>
import jdProvinceCity from '@/views/jdOldMachineRecycleManage/mixins/jdProvinceCity.js'
import totalPriceUpdateModal from './components/TotalPriceUpdateModal.vue'
import FileUpload from '@/components/Upload/fileUpload'
import dayjs from 'dayjs'

export default {
  mixins: [jdProvinceCity],
  components: {
    totalPriceUpdateModal,
    FileUpload
  },
  data() {
    return {
      searchData: {
        province: undefined,
        city: undefined,
        recycler: undefined,
        startTotalDate: undefined,
        endTotalDate: undefined
      },
      totalDate: [this.getCurrentDate(), this.getCurrentDate()],
      tableData: [],
      oldMachineEnum: [],
      provinceList: [],
      cityList: [],
      districtListNew: [],
      specificationsList: [],
      total: 0,
      pagination: {
        page: 1,
        rows: 10
      },
      tableLoading: false,
      selectList: [],
      exportFlag: false,
      totalPrice: 0,
      totalInfoFee: 0,
      orgTypeList: [],
      dialogVisible: false,
      defaultLoading: false,
      Default: true,
      defaultUpLoadData: {},
      dayPickerOptions: {
        disabledDate: time => {
          const today = dayjs().startOf('day')
          return dayjs(time).isAfter(today, 'day')
        },
        onPick: ({ maxDate, minDate }) => {
          if (maxDate) {
            const diffDays = dayjs(maxDate).diff(dayjs(minDate), 'day')
            if (diffDays > 365) {
              this.totalDate = [this.getCurrentDate(), this.getCurrentDate()]
              this.$message.warning('最多只能选择1年')
            }
          }
        }
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        setTimeout(() => {
          if (!this.global.handleEmptyData(this.defaultUpLoadData)) {
            this.$refs.Defaultfileupload.$refs.upload.clearFiles()
          }
          this.defaultUpLoadData = {}
          this.Default = true
        }, 100)
      }
    }
  },
  mounted() {
    this.getTblProvinceNew()
    this.handleSearch()
    this.getTblCity()
    // this.getOrgTypeList()
    this.getSpecifications()
  },
  methods: {
    // 获取当前日期
    getCurrentDate() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // 省改变
    getTblCity() {
      this.searchData.city = ''
      return this.HttpService.get(`/autoapp-default-server-recovery/api/settlement/orderTotal/getCityByProvince?province=${this.searchData.province}`).then(res => {
        if (res.statusCode === 200) {
          this.cityList = res.data
        }
      })
    },
    getTblProvince() {
      this.searchData.city = ''
      return this.HttpService.get('/autoapp-default-server-recovery/api/settlement/orderTotal/getProvince').then(res => {
        if (res.statusCode === 200) {
          this.provinceList = res.data
        }
      })
    },
    //获取列表
    getList() {
      const url = `/autoapp-default-server-recovery/api/settlement/orderTotal/pageCondition`
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      params.startTotalDate = dayjs(this.totalDate[0]).format('YYYY-MM-DD')
      params.endTotalDate = dayjs(this.totalDate[1]).format('YYYY-MM-DD')
      return this.HttpService.post(url, this.global.clearEmptyParam(params)).then(res => {
        if (res.statusCode === 200) {
          this.total = res.data.total || 0
          const resData = res.data.records || []
          this.tableData = resData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 获取规格
    getSpecifications() {
      const url = '/autoapp-default-server-recovery/api/settlement/orderPrice/getSpecificationsList'
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          console.log('res===', res)
          const resData = res.data || []
          this.specificationsList = resData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },

    // 查询
    handleSearch() {
      this.pagination.page = 1
      this.getList()
      this.getTotalPrice()
    },
    // 清空
    resetForm() {
      // 重置搜索条件
      Object.assign(this.searchData, {
        startTotalDate: undefined,
        endTotalDate: undefined,
        province: undefined,
        city: undefined,
        recycler: undefined
      })
      this.totalDate = [this.getCurrentDate(), this.getCurrentDate()]
      this.getList()
    },
    // 页码改变
    handleSizeChange(val) {
      this.pagination.page = 1
      this.pagination.rows = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    // 导出
    exportBtnFun() {
      this.exportFlag = true
      setTimeout(() => {
        this.exportFlag = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/settlement/orderTotal/exportPageCondition'
      const title = '旧机结算统计数据'
      const params = {
        ...this.searchData
      }
      params.startTotalDate = dayjs(this.totalDate[0]).format('YYYY-MM-DD')
      params.endTotalDate = dayjs(this.totalDate[1]).format('YYYY-MM-DD')

      this.HttpService.post(url, this.global.clearEmptyParam(params)).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    openTotalPriceUpdateModal(row) {
      const { id } = row
      this.$refs.totalPriceUpdateModalRef.openDialog(row)
    },
    handleSave(row) {
      const { id } = row
      const url = `/autoapp-default-server-recovery/api/settlement/orderTotal/archive`
      return this.HttpService.post(url, { id: id }).then(res => {
        if (res.statusCode === 200) {
          this.$message.success('存档成功')
          this.getList()
        } else {
          const msgTip = res.message || '请求出错, 请重试'
          this.$message.error(msgTip)
        }
      })
    },
    handleDelete(row) {
      const { id } = row
      const url = `/autoapp-default-server-recovery/api/settlement/orderTotal/deleteById/${id}`
      return this.HttpService.delete(url).then(res => {
        if (res.statusCode === 200) {
          this.$message.success('删除成功')
          this.getList()
          this.getTotalPrice()
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },

    getTotalPrice() {
      const url = `/autoapp-default-server-recovery/api/settlement/orderTotal/totalPricePageCondition`
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      params.startTotalDate = dayjs(this.totalDate[0]).format('YYYY-MM-DD')
      params.endTotalDate = dayjs(this.totalDate[1]).format('YYYY-MM-DD')
      return this.HttpService.post(url, this.global.clearEmptyParam(params)).then(res => {
        if (res.statusCode === 200) {
          this.totalPrice = res.data !== null ? res.data.totalPrice : 0
          this.totalInfoFee = res.data !== null ? res.data.totalInfoFee : 0
        }
      })
    },

    // 获取回收商
    getOrgTypeList() {
      const url = '/autoapp-recovery-server-auth/api/tbl-partner-management/page'
      let params = {
        pageNum: 1,
        pageSize: 500,
        partnerName: '',
        partnershipType: 2
      }
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          const resData = res.data.records || []
          this.orgTypeList = resData.map(item => item.partnerName || '')
          console.log('this.orgTypeList===', this.orgTypeList)
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    importOrder() {
      this.dialogVisible = true
    },

    //普通订单
    importUpdateDefaultByExcel(item) {
      this.defaultLoading = true
      this.defaultUpLoadData = item
    },
    removueFile() {
      this.Default = true
      this.defaultUpLoadData = {}
    },
    download() {
      this.global.exportExcel('/autoapp-default-server-recovery/api/settlement/orderTotal/downloadTemplate', {}, '旧机结算统计更新模版').catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    submitExcel() {
      if (this.global.handleEmptyData(this.defaultUpLoadData)) {
        this.$message.error('请上传文件')
      } else {
        // 添加全局loading
        const loading = this.$loading({
          lock: true,
          text: '数据导入中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        let formData = new FormData()
        if (!this.global.handleEmptyData(this.defaultUpLoadData)) {
          formData.append('file', this.defaultUpLoadData.file)
          this.HttpService.post('/autoapp-default-server-recovery/api/settlement/orderTotal/importData', formData)
            .then(res => {
              // 关闭loading
              loading.close()

              if (res.statusCode !== 200) {
                return this.$message.error(res.message)
              }
              if (res.data != null) {
                this.$message.error('文件有误, 请查看错误报告')
                this.getErrorReport(res.data)
              } else {
                this.$message.success('导入成功')
                this.dialogVisible = false
                this.getList()
                this.getTotalPrice()
              }
            })
            .catch(error => {
              // 异常时关闭loading
              loading.close()
              this.$message.error('导入失败')
            })
        } else {
          // 关闭loading
          loading.close()
        }
        this.dialogVisible = false
      }
    },
    getErrorReport(downLoadId) {
      const url = `/autoapp-default-server-recovery/api/file/downLoadFailById`
      this.global.exportExcel(url, { downId: downLoadId }, '错误文件').catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },

    handleDayChange(dates) {
      if (dates && dates.length === 2) {
        const diffDays = dayjs(dates[1]).diff(dayjs(dates[0]), 'day')
        if (diffDays > 365) {
          this.totalDate = []
        }
      }
      this.searchData.startTotalDate = dayjs(dates[0]).format('YYYY-MM-DD')
      this.searchData.endTotalDate = dayjs(dates[1]).format('YYYY-MM-DD')
    }
  }
}
</script>
<style scoped lang="scss">
.row-bg {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
.btnclass {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/settlementManagement/oldMachineSettlement.vue